import { render, staticRenderFns } from "./ko.vue?vue&type=template&id=dcbc9c44&scoped=true&"
import script from "./ko.vue?vue&type=script&lang=js&"
export * from "./ko.vue?vue&type=script&lang=js&"
import style0 from "./ko.vue?vue&type=style&index=0&id=dcbc9c44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbc9c44",
  null
  
)

export default component.exports